import clsx from 'clsx';
import { Icon } from '../../icon/Icon';
import { TableCellParams } from '../../table/interfaces/table';
import { Tooltip } from '../../tooltip/Tooltip';
import { RecipientActions } from './RecipientActions';
import styles from './ManageRecipients.module.scss';
import { Recipient } from './interface';
import { PROFILE_IMAGE } from './constant';

export const RecipientListColumns = [
  {
    id: 'c1',
    field: 'channel_identifier',
    headerName: 'Recipient',
    width: 180,
    wrapOverflowingCellText: true,
    renderCell: (params: TableCellParams<Recipient>) => (
      <div className='d-flex overflow-hidden align-items-center'>
        {params.row.data.channel_type === 'user' ? (
          <img
            data-id='user-profile-image'
            src={PROFILE_IMAGE}
            style={{ width: '20px' }}
            className='mr-2'
            alt='user-profile-image'
            aria-hidden='true'
          />
        ) : (
          <Icon
            name={params.row.data.channel_type}
            size={3}
            className='mr-2'
            dataId={`${params.row.data.channel_identifier}-${params.row.data.channel_type}`}
          />
        )}

        <Tooltip dataId='' title={params.row.data.channel_identifier} enableOnTextOverflow>
          <div className='text-ellipsis text-body-2'>{params.row.data.channel_identifier}</div>
        </Tooltip>

        {params.row.active ? (
          <div
            className={clsx(styles.activeRecipientBadge, 'text-body-2 ml-1 px-3 py-1')}
            data-id='active-recipient-tag'
          >
            Active
          </div>
        ) : null}
      </div>
    )
  },

  {
    id: 'c2',
    field: 'added_by',
    headerName: 'Added By',
    width: 120,
    wrapOverflowingCellText: true,
    renderCell: (params: TableCellParams<Recipient>) => (
      <div>
        <span className={clsx('text-body-2', styles.addedByText)}>{params.row.data.added_by}</span>
        <RecipientActions rowData={params.row} />
      </div>
    )
  }
];
